import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store/index'
// import Navigation from "vue-navigation";
// import Navigation from "vue-navigation/src/components/Navigation";
import VueAMap from "vue-amap";
import './assets/scss/animate.scss'
import './assets/scss/style.scss'
import VueWechatTitle from 'vue-wechat-title'
import VueCookies from 'vue-cookies'
import {Image} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Toast from '@/components/Toast';

Vue.component('Toast', Toast);

import {
  API_CODE,
  EXCHANGE_REDUCE,
  GOODS,
  MEMBER_GAME,
  ORDER_STATUS,
  ORDERS_CANCEL,
  ORDERS_STATUS
} from './store/mutation-types'


Vue.prototype.$API_CODE = API_CODE;
Vue.prototype.$ORDER_STATUS = ORDER_STATUS;
Vue.prototype.$ORDERS_STATUS = ORDERS_STATUS;
Vue.prototype.$ORDERS_CANCEL = ORDERS_CANCEL;
Vue.prototype.$EXCHANGE_REDUCE = EXCHANGE_REDUCE;
Vue.prototype.$MEMBER_GAME = MEMBER_GAME;
Vue.prototype.$GOODS = GOODS;

Vue.use(Image);

Vue.use(VueAMap);
// Vue.use(Navigation, {router});
Vue.use(VueWechatTitle);

Vue.use(VueCookies);
//配置默认过期日期:365天
VueCookies.config("365d");

VueAMap.initAMapApiLoader({
  key: 'a7ee07f09c8a899aa6d79ee2b1640b93',
  plugin: [

    'Autocomplete',

    'PlaceSearch',

    'Scale',

    'OverView',

    'ToolBar',

    'MapType',

    'PolyEditor',

    'AMap.CircleEditor',

    'AMap.Geolocation'

  ],
    uiVersion: '1.0.11' // 版本号
});

Vue.config.productionTip = false;




new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app');
